import React from 'react'
import {
  LineChart,
  Line,
  XAxis,
  LabelList,
  ResponsiveContainer,
} from 'recharts'

import {
  Typography,
  Spinner,
  Badge
} from '@telavita-core/react-design-kit'

import ArrowLeftIcon from 'components/CoreIcons/Icons/ArrowLeft'
import ArrowRightIcon from 'components/CoreIcons/Icons/ArrowRight'
import { CustomizedLabel } from '../CustomizedLabel'

import { ISchedulesAverageData } from '../../types'

import {
  Arrows,
  GraphicContainer,
  GraphicWrapper,
  Loading,
  EmptyMessage,
  LeftSection
} from './styles'

interface ICustomizedLineChartProps {
  loading: boolean
  data: ISchedulesAverageData[]
  activeTab: number
  navLeft: () => void
  navRight: () => void
  rightArrowDisable: boolean
  getLastMonthData: () => { average: string, month: string }
}

export const CustomizedLineChart = ({
  loading,
  data,
  activeTab,
  navLeft,
  navRight,
  rightArrowDisable,
  getLastMonthData
}: ICustomizedLineChartProps): JSX.Element => {
  const getMessageByAverageQuantity = () => {
    const lastMonthAverage = getLastMonthData()?.average

    return (
      <p>
        {lastMonthAverage === '1,0' ? 'Consulta' : 'Consultas'}<br />
        {lastMonthAverage === '1,0' ? 'realizada' : 'realizadas'}<br />
        em <span>{getLastMonthData()?.month}</span>
      </p>
    )
  }

  const emptyDataMessage = {
    0: 'Nenhuma consulta para esta data.',
    1: 'Você não atende nenhum convênio com consultas quinzenais.'
  }

  return (
    <GraphicContainer>

      {loading && (
        <Loading>
          <Spinner />
        </Loading>
      )}

      {!data.length && !loading && (
        <EmptyMessage>
          <Typography
            variant='content3'
            center
          >
            {emptyDataMessage[activeTab]}
          </Typography>
        </EmptyMessage>
      )}

      <Arrows
        isLoading={loading}
        isEmpty={!data.length}
      >
        <button onClick={navLeft}>
          <ArrowLeftIcon 
            fill='#4b4b4b'
            height='24px'
            width='24px'
          />
        </button>
        <button
          onClick={navRight}
          disabled={rightArrowDisable}
        >
          <ArrowRightIcon 
            fill='#4b4b4b'
            height='24px'
            width='24px'
          />
        </button>
      </Arrows>

      <GraphicWrapper
        isLoading={loading}
        isEmpty={!data.length}
      >
                
        <LeftSection>
          <Typography
            color='primary'
            weight='bolder'
            inlineStyles={{
              fontSize: '35px',
              lineHeight: '35px',
            }}
          >
            {getLastMonthData()?.average}
          </Typography>
          <Typography variant='content3'>
            {getMessageByAverageQuantity()}
          </Typography>
          <Badge
            colorScheme='blue'
          >
            <Typography
              color='primary'
              variant='content3'
            >
              {`IDEAL: ${activeTab === 0 ? '4,0' : '2,0'}`}
            </Typography>
          </Badge>
        </LeftSection>

        <ResponsiveContainer width='100%' height={110}>
          <LineChart
            margin={{
              left: 30,
              right: 30,
              top: 20,
            }}
            data={data}
          >
            <Line 
              dataKey='average'
              stroke='#1f35b5'
              dot={{ fill: '#1f35b5' }}
              animationDuration={500}
            >
              <LabelList 
                content={
                  <CustomizedLabel
                    stroke='#4b4b4b'
                  />
                }
              />
            </Line>
            <XAxis
              dataKey='month'
              type='category'
              name='months'
              axisLine={false}
              tickLine={false}
              xAxisId={0}
              fontSize={12}
              style={{
                textTransform: 'capitalize'
              }}
              stroke='#4b4b4b'
            />
            <XAxis
              dataKey='year'
              type='category'
              name='year'
              axisLine={false}
              tickLine={false}
              xAxisId={1}
              dy={-15}
              dx={-3}
              height={5}
              fontSize={12}
              stroke='#adadad'
            />
          </LineChart>
        </ResponsiveContainer>
      </GraphicWrapper>

    </GraphicContainer>
  )
}